/**
 * Category color tokens — measured with getComputedStyle on the prototype
 * (not estimated), mapped to the nearest Tailwind token. All 9 categories the
 * prototype defines are covered (the prototype's `CATEGORIES` array assigns a
 * color to each). Measured tones are from dark theme; light drops to the
 * 600/700 band for AA contrast.
 */
export const CATEGORY_COLOR_CLASS = {
  'Ticketing & ITSM': 'text-amber-600 dark:text-amber-400', // #FDC700
  Storage: 'text-pink-600 dark:text-pink-500', // #EC4899
  'Productivity & Docs': 'text-violet-600 dark:text-violet-400', // #A78BFA
  'CRM & Sales': 'text-emerald-600 dark:text-emerald-400', // #05DF72
  'Security & Observability': 'text-violet-700 dark:text-violet-500', // #8B5CF6
  Communication: 'text-blue-600 dark:text-blue-400', // #2B7FFF
  'Data & Analytics': 'text-cyan-600 dark:text-cyan-400', // #06B6D4
  'Dev & Code': 'text-red-600 dark:text-red-400', // #EF4444
  'Custom / Build your own': 'text-gray-600 dark:text-gray-400', // #6B7280
};

/** Color class for a category, or '' when the category has no Design-defined color. */
export const getCategoryColorClass = (category) => CATEGORY_COLOR_CLASS[category] ?? '';
